export const fr = {
    // Login screen
    modal_login_capital: 'IDENTIFIANT',
    placeholder_email_address: "étiquetter l'email",
    placeholder_password: 'étiquetter le mot de passe',
    tooltip_forgot_password: 'mot de passe oublié?',
    log_in: 'identifiant',

    // Register screen
    modal_signup_capital: 'INSCRIPTION',
    placeholder_repeat_password: 'ressaisir le mot de passe',
    agree: "J'accèpte les ",
    terms: 'Conditions',
    modal_register_capital: "s'inscrire",
    full_name: 'Nom complet',

    // Price options
    choose_price: 'CHOISISSEZ VOTRE PRIX',
    subscription_price: 'Abonnement',
    asset_price: 'Actif',
    paywall_subscription_text:
        'Vous pouvez annuler votre abonnement à tout moment.',
    modal_back: 'RETOUR',
    next_button: 'SUIVANT',

    // Payments screen
    pay: 'PAYER',
    pay_with: 'PAYER AVEC PAYPAL',
    credit_card: 'carte de crédit',
    payment_pay: 'Payer',
    payment_price: 'Prix',
    placeholder_voucher_code: 'code coupon',
    placeholder_voucher: 'ajouter un coupon',
    card_number: 'numéro de carte',
    cardholder_name: 'nom du titulaire de la carte',

    // Forgot password
    forgot_pass_text:
        'Nous vous enverrons un lien par e-mail pour réinitialiser votre mot de passe.',
    remember_pass: 'Se souvenir du mot de passe?',
    reset: 'RÉINITIALISER',

    // Set new password
    modal_enter_your_new_password: 'Entrez votre nouveau mot de passe.',
    modal_please_check_your_email:
        'Veuillez vérifier votre courrier électronique et copier le token pour continuer.',
    placeholder_token: 'token',
    new_password: 'nouveau mot de passe',
    repeat_new_password: 'ressaisir le nouveau mot de passe',
    cancel: 'annuler',
    set: 'CONFIGURER',

    // Change password
    update: 'mettre à jour',
    change_pass: 'Change password',

    // Account
    user_menu_my_account: 'Mon compte',
    member_since: 'Membre depuis',
    purchases: 'Mes achats',
    subscriptions: 'Mes abonnements',
    account_details: 'Détails du compte',
    export_data: 'Exporter mes données',
    delete_account: 'Supprimer le compte',
    email: 'Email',

    // Purchases/Subscriptions
    purchases_link: 'Achats',
    subscriptions_link: 'Abonnements',
    subscriptions_text:
        'These are all the assets you have purchased and how long you have access to it.',
    purchase_history: 'Historique des achats',
    purchased: 'Acheté',
    name: 'Nom',
    active: 'actif',
    inactive: 'Inactive',
    canceled: 'annulé',
    type: 'Type',
    next_transaction: 'Transaction suivante',
    cancel_subscription: "Annuler l'abonnement >",
    subscriptions_active: 'Abonnements actifs',
    expires_at: 'Expire le',
    no_more_subscriptions: "Il n'y a plus d'abonnement.",
    no_available_subscriptions: "Il n'y a pas d'abonnement disponible.",
    no_more_active_accesses: "Il n'y a plus d'accès actif.",
    no_more_inactive_accesses: "Il n'y a plus d'accès inactif.",
    no_available_active_accesses: "Il n'y a aucun accès actif disponible.",
    no_available_inactive_accesses: "Il n'y a pas d'accès inactif disponible.",
    subscription: 'Subscription',
    free_trial: 'Free Trial',
    cancel_subscription_header:
        'Are you sure you want to cancel your subscription?',
    cancel_subscription_paragraph_first:
        'This will end your subscription for the',
    cancel_subscription_paragraph_second:
        'You will still have access to everything until the active period ends on the',
    cancel_subscription_confirm: 'Yes, cancel',
    will_end: 'Subscription will end',

    // Export data screen
    export_question:
        'Êtes-vous sûr de vouloir exporter les données de votre compte?',
    export: 'exporter',
    first_export:
        "L'action Exporter les données du compte exportera toutes les données personnelles de votre compte. Cela inclut :",
    second_export: 'Vos informations personnelles',
    third_export: 'La liste de vos enregistrements de connexion',
    fourth_export: 'La liste de vos abonnements',
    fifth_export: 'La liste de vos paiements',
    sixth_export: 'La liste de vos accès au contenu premium',
    last_export:
        "L'exportation sera envoyée à votre adresse e-mail en pièce jointe.",

    // Delete account screen
    delete_question: 'Êtes-vous certain de vouloir supprimer votre compte?',
    delete: 'supprimer',
    confirm: 'CONFIRMER',
    first_delete:
        "L'action Supprimer le Compte effacera toutes vos données personnelles du système. Cela inclut :",
    second_delete:
        'Les informations personnelles que vous avez fournies lors de votre inscription',
    third_delete:
        "Les informations sur votre localisation et votre appareil que nous recueillons lors du processus d'authentification",
    fourth_delete:
        "Toutes les autres informations personnelles stockées dans d'autres parties de notre base de données ",
    fifth_delete:
        "Les seules données personnelles que nous conserverons dans le système sont celles qui font partie des enregistrements de transactions et d’abonnements et ce en application d'autres lois que nous devons respecter.",
    sixth_delete:
        "En plus de l'effacement des données, votre compte sera également désactivé, ce qui signifie que tous vos abonnements actifs seront annulés, que tous vos accès actifs aux actifs seront révoqués et que toutes vos sessions de connexion actives, y compris celle-ci, seront interrompues. Vous ne pourrez plus authentifier ni acheter des actifs sur ce site. Vos informations de compte ne seront plus accessibles à notre personnel dans aucune liste.",
    seventh_delete:
        'Cette action peut prendre 1 à 2 jours, après quoi un e-mail de confirmation sera envoyé à votre adresse e-mail. Cet e-mail sera effacé de notre système après avoir été délivré avec succès.',

    // Inputs validation
    required_field: 'Champ obligatoire',
    email_field: 'veuillez entrer un e-mail valide',
    number_field: 'La valeur doit être un nombre',
    matchPass: 'le mot de passe ne correspond pas',
    minpass_field: 'doit comporter au moins 8 caractères',
    minname_field: 'doit comporter au moins 2 caractères',

    // Footer
    modal_terms: 'Conditions',
    modal_privacy: 'Confidentialité',
    modal_more: 'PLUS',
    modal_faq: 'FAQ',
    modal_protected: "Qu'est-ce que c'est?",
    logout: 'Déconnexion',
    details: 'Mes informations',
    preview_protected_by_inplayer: 'Protégé par',
    modal_support: 'Support',

    dlc_download: 'télécharge',
};



// WEBPACK FOOTER //
// ./src/i18n/french.js